<template>
  <v-container
    class="legal-page-layout py-6 py-md-10"
    fluid
  >
    <v-row justify="center">
      <v-col
        cols="12"
        lg="10"
        xl="8"
      >
        <v-card
          class="legal-page-card overflow-hidden"
          elevation="8"
        >
          <v-card-title class="primary white--text pa-6 pa-md-8">
            <div
              class="d-flex flex-column flex-md-row align-start align-md-center justify-space-between"
              style="width: 100%"
            >
              <div class="pr-md-6">
                <div class="text-overline white--text text--lighten-2 mb-2">
                  Campag ERP
                </div>
                <h1 class="text-h4 text-md-h3 font-weight-bold mb-2">
                  {{ title }}
                </h1>
                <div class="text-subtitle-1 white--text text--lighten-2">
                  Última atualização: {{ updatedAt }}
                </div>
              </div>

              <div class="mt-4 mt-md-0">
                <v-btn
                  class="white--text"
                  color="white"
                  outlined
                  :to="{ path: '/login' }"
                >
                  Voltar ao login
                </v-btn>
              </div>
            </div>
          </v-card-title>

          <v-card-text class="pa-5 pa-md-8">
            <slot />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'LegalPageLayout',

    props: {
      title: {
        type: String,
        required: true,
      },

      updatedAt: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style scoped>
.legal-page-layout {
  min-height: 100vh;
  background: linear-gradient(180deg, rgba(244, 246, 248, 0.96) 0%, rgba(235, 240, 246, 1) 100%);
}

.legal-page-card {
  border-radius: 16px;
}
</style>
